import React from 'react';
import {
  Chip,
  Tooltip,
  Box,
} from '@mui/material';
import {
  WarningAmber as WarningIcon,
  ContentCopy as DuplicateIcon,
} from '@mui/icons-material';
import PropTypes from 'prop-types';

const DuplicateDataIndicator = ({
  isDuplicate,
  duplicateCount,
  originalDataId,
  currentDataId,
}) => {
  if (!isDuplicate || duplicateCount === 0) {
    return null;
  }

  const getDuplicateColor = (count) => {
    if (count === 1) return 'warning';
    if (count === 2) return 'error';
    return 'error';
  };

  const getDuplicateIcon = (count) => {
    if (count === 1) return <WarningIcon fontSize="small" />;
    return <DuplicateIcon fontSize="small" />;
  };

  const getTooltipText = () => {
    if (duplicateCount === 1) {
      return `This data has 1 duplicate in the system`;
    }
    return `This data has ${duplicateCount} duplicates in the system`;
  };

  return (
    <Box display="flex" alignItems="center" gap={0.5}>
      <Tooltip title={getTooltipText()}>
        <Chip
          icon={getDuplicateIcon(duplicateCount)}
          label={`${duplicateCount} dup`}
          size="small"
          color={getDuplicateColor(duplicateCount)}
          variant="filled"
          sx={{
            fontSize: '0.7rem',
            height: '20px',
            '& .MuiChip-label': {
              padding: '0 4px',
            },
            '& .MuiChip-icon': {
              fontSize: '14px',
            },
          }}
        />
      </Tooltip>
      
      {originalDataId && originalDataId !== currentDataId && (
        <Tooltip title="Showing original data (duplicate detected)">
          <Chip
            label="Original"
            size="small"
            color="info"
            variant="outlined"
            sx={{
              fontSize: '0.65rem',
              height: '18px',
              '& .MuiChip-label': {
                padding: '0 3px',
              },
            }}
          />
        </Tooltip>
      )}
    </Box>
  );
};

DuplicateDataIndicator.propTypes = {
  isDuplicate: PropTypes.bool.isRequired,
  duplicateCount: PropTypes.number.isRequired,
  originalDataId: PropTypes.number,
  currentDataId: PropTypes.number,
};

DuplicateDataIndicator.defaultProps = {
  originalDataId: null,
  currentDataId: null,
};

export default DuplicateDataIndicator;